import React from 'react';

import classNames from 'classnames';

interface DotBricksLoadingProps {
  className?: string;
}

const DotBricksLoading: React.FC<DotBricksLoadingProps> = ({ className = '' }) => {
  return (
    <div className={classNames('flex flex-grow h-full', className)} data-testid="loading">
      <div className="dot-bricks m-auto" />
    </div>
  );
};

export default DotBricksLoading;
